(function () {
  'use strict';

  var T = window.THVSN || { routes: { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root: '/' }, moneyFormat: '${{amount}}', freeShipThreshold: 0, freeShipOn: false };
  var root = (T.routes.root || '/').replace(/\/$/, '');

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100);
    var amount = value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = T.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toast(msg) {
    var el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 2200);
  }

  /* ---------- open / close panels ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var f = el.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.is-open.mobile-menu, .is-open.drawer, .is-open.filters')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.mobile-menu.is-open, .drawer.is-open, .filters.is-open').forEach(closePanel);
  });

  /* ---------- announcement rotate ---------- */
  $$('[data-rotate]').forEach(function (wrap) {
    var slides = $$('.announce__slide', wrap);
    if (slides.length < 2) return;
    var i = 0;
    var ms = (parseInt(wrap.getAttribute('data-rotate'), 10) || 4) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, ms);
  });

  /* ---------- header: menu + search ---------- */
  var mobileMenu = $('#MobileMenu');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openPanel(mobileMenu); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closePanel(mobileMenu); }); });

  var searchBar = $('[data-search-bar]');
  $$('[data-search-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!searchBar) return;
      e.preventDefault();
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) { var i = $('input[type="search"]', searchBar); if (i) i.focus(); }
    });
  });

  /* ---------- cart ---------- */
  var drawer = $('#CartDrawer');

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderShip(cart) {
    var tiers = T.tiers;
    var text = $('[data-ship-text]');
    var bar = $('[data-ship-bar]');
    if (!T.freeShipOn || !tiers || !text || !bar) return;
    var giftId = tiers.giftVariant;
    var hasGift = false, sub = 0;
    cart.items.forEach(function (it) {
      if (giftId && it.variant_id === giftId && !hasGift) { hasGift = true; sub += Math.max(0, it.original_line_price - it.original_price); }
      else { sub += it.original_line_price; }
    });
    var t1 = tiers.t1, t2 = tiers.t2;
    if (sub < t1) text.textContent = "You're " + formatMoney(t1 - sub) + ' away from ' + tiers.t1Name;
    else if (sub < t2) text.textContent = 'You unlocked ' + tiers.t1Name + '. ' + formatMoney(t2 - sub) + ' more for ' + tiers.t2Name;
    else text.textContent = 'You unlocked ' + tiers.t1Name + ' and ' + tiers.t2Name;
    bar.style.width = Math.min(100, Math.round((sub / t2) * 100)) + '%';
    var mark = $('[data-tier-marker]');
    if (mark) { mark.style.left = Math.round((t1 / t2) * 100) + '%'; mark.classList.toggle('is-hit', sub >= t1); }
    var add = $('[data-gift-add]');
    if (add) add.hidden = !(giftId && sub >= t1 && !hasGift);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gift-add]');
    if (!b || !T.tiers || !T.tiers.giftVariant) return;
    b.disabled = true;
    addToCart(T.tiers.giftVariant, 1).then(refreshCart).catch(function (err) { toast(err.message); }).then(function () { b.disabled = false; });
  });

  function renderCart(cart) {
    updateCount(cart.item_count);
    renderShip(cart);
    var body = $('[data-cart-items]');
    var sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (!body) return;
    if (!cart.items.length) { body.innerHTML = '<p class="drawer__empty">Your cart is empty</p>'; return; }
    body.innerHTML = cart.items.map(function (item, idx) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy" width="84">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="citem__var">' + escapeHtml(item.variant_title) + '</p>' : '';
      var discounts = (item.line_level_discount_allocations || []).map(function (d) {
        return '<p class="citem__disc">' + escapeHtml(d.discount_application.title) + '</p>';
      }).join('');
      return '<div class="citem">' +
        '<a class="citem__img" href="' + item.url + '">' + img + '</a>' +
        '<div class="citem__info">' +
          '<a class="citem__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant + discounts +
          '<div class="citem__qty">' +
            '<div class="qty">' +
              '<button type="button" data-qty="' + (idx + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty="' + (idx + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="citem__remove" data-qty="' + (idx + 1) + '" data-to="0">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="citem__price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refreshCart() { return fetchCart().then(renderCart); }

  function changeLine(line, qty) {
    return fetch(T.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, qty) {
    return fetch(T.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  if (drawer) {
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCart();
        openPanel(drawer);
      });
    });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { closePanel(drawer); }); });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      b.disabled = true;
      changeLine(Number(b.getAttribute('data-qty')), Math.max(0, Number(b.getAttribute('data-to'))));
    });
    refreshCart();
  }

  /* ---------- quick add on cards ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card__size');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    addToCart(btn.getAttribute('data-variant-id'), 1)
      .then(function () {
        btn.classList.add('is-added');
        return refreshCart();
      })
      .then(function () { if (drawer) openPanel(drawer); })
      .catch(function (err) { toast(err.message); })
      .then(function () {
        btn.disabled = false;
        setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
      });
  });

  /* ---------- product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var input = $('[data-variant-input]', section);
    var addBtn = $('[data-add-btn]', section);
    var dynamic = $('[data-dynamic-checkout]', section);
    var errorEl = $('[data-form-error]', section);
    var priceEl = $('[data-pdp-price] .price__now', section);
    var wasEl = $('[data-pdp-price] .price__was', section);
    var fieldsets = $$('fieldset[data-option-index]', section);

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability() {
      // Cross out values that have no available variant with the other current selections
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.closest('.opt__btn').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      fieldsets.forEach(function (fs, i) {
        var label = $('[data-option-value]', fs);
        if (label) label.textContent = opts[i] || '';
      });
      markAvailability();
      if (!addBtn) return;
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        if (dynamic) dynamic.hidden = true;
        return;
      }
      input.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (dynamic) dynamic.hidden = !v.available;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (wasEl) wasEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability();

    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        var label = addBtn.textContent;
        addBtn.textContent = 'Adding...';
        if (errorEl) errorEl.hidden = true;
        addToCart(input.value, 1)
          .then(refreshCart)
          .then(function () { if (drawer) openPanel(drawer); })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .then(function () { addBtn.disabled = false; addBtn.textContent = label; });
      });
    }

    // gallery dots on mobile
    var list = $('.pdp__media-list', section);
    var dots = $$('.pdp__dot', section);
    if (list && dots.length) {
      list.addEventListener('scroll', function () {
        var i = Math.round(list.scrollLeft / list.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }
  });

  /* ---------- drops: countdowns + labels ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  var countdowns = $$('[data-countdown]');
  var dropCards = $$('.card[data-drop-ts]');
  var pdpDrop = $('[data-product-section][data-drop-ts]');

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    countdowns.forEach(function (el) {
      var target = Number(el.getAttribute('data-countdown'));
      var diff = Math.max(0, target - now);
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var set = function (sel, val) { var x = el.querySelector(sel); if (x) x.textContent = pad(val); };
      set('[data-d]', d); set('[data-h]', h); set('[data-m]', m); set('[data-s]', s);
      if (diff === 0 && el.hasAttribute('data-reload-on-zero') && !el._reloaded) {
        el._reloaded = true;
        // Give Shopify a few seconds so inventory you release at drop time is live
        setTimeout(function () { window.location.reload(); }, 3000);
      }
    });
    // Page cache can be a few minutes old. If a card's drop time passed, drop the label.
    dropCards.forEach(function (card) {
      if (Number(card.getAttribute('data-drop-ts')) <= now) {
        var label = card.querySelector('[data-drop-label]');
        if (label) label.textContent = 'Live now';
        card.classList.remove('card--upcoming');
      }
    });
  }
  if (countdowns.length || dropCards.length) { tick(); setInterval(tick, 1000); }

  // Product page: once drop time passes, swap the locked button for the live one.
  // Keep inventory at 0 until drop time, so the live button is only usable once stock is released.
  function unlockPdp() {
    if (!pdpDrop) return;
    if (Number(pdpDrop.getAttribute('data-drop-ts')) > Math.floor(Date.now() / 1000)) return;
    var locked = pdpDrop.querySelector('[data-buy-locked]');
    var live = pdpDrop.querySelector('[data-buy-live]');
    var box = pdpDrop.querySelector('[data-drop-box]');
    if (locked) locked.remove();
    if (live) live.hidden = false;
    if (box) box.hidden = true;
    pdpDrop = null;
  }
  unlockPdp();
  if (pdpDrop) setInterval(unlockPdp, 1000);

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    if (el.children.length) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- collection filters ---------- */
  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    var panel = $('[data-filters]', filterForm);
    $$('[data-filters-open]', filterForm).forEach(function (b) { b.addEventListener('click', function () { openPanel(panel); }); });
    $$('[data-filters-close]', filterForm).forEach(function (b) { b.addEventListener('click', function () { closePanel(panel); }); });
    var sort = $('[data-sort]', filterForm);
    if (sort) sort.addEventListener('change', function () { filterForm.submit(); });
    filterForm.addEventListener('submit', function () {
      // Drop empty price inputs so the URL stays clean
      $$('input[type="number"]', filterForm).forEach(function (i) { if (!i.value) i.disabled = true; });
    });
  }
})();
